import Phaser from 'phaser'

import SceneKeys from '../consts/SceneKeys'

export default class GameOver extends Phaser.Scene {
  private isMobile = false

  constructor() {
    super(SceneKeys.GameOver)
  }

  create(data: { deathCause?: 'flag' | 'drone'; score?: number }) {
    const { width, height } = this.scale

    // Detect if mobile/touch device
    this.isMobile = this.sys.game.device.input.touch || !this.sys.game.device.os.desktop

    const x = width * 0.5
    const y = height * 0.5

    // Add semi-transparent dark overlay
    const overlay = this.add.rectangle(0, 0, width, height, 0x000000, 0.85)
    overlay.setOrigin(0, 0)

    // Determine the message based on death cause
    const diedByFlag = data.deathCause === 'flag'
    const diedByDrone = data.deathCause === 'drone'
    const titleMessage = diedByFlag ? 'YOU HAVE BEEN RADICALIZED' : 'IDENTITY CONFIRMED'

    // Main title
    const titleText = this.add
      .text(x, y - 80, titleMessage, {
        fontSize: diedByFlag ? '42px' : '48px',
        color: '#FF0000',
        fontStyle: 'bold',
        stroke: '#000000',
        strokeThickness: 4,
        shadow: { offsetX: 3, offsetY: 3, color: '#000000', blur: 5, fill: true },
      })
      .setOrigin(0.5)
      .setAlpha(0)

    // Subtitle: "GAME OVER"
    const gameOverText = this.add
      .text(x, y, 'GAME OVER', {
        fontSize: '64px',
        color: '#FFFFFF',
        fontStyle: 'bold',
        stroke: '#000000',
        strokeThickness: 6,
        shadow: { offsetX: 4, offsetY: 4, color: '#000000', blur: 8, fill: true },
      })
      .setOrigin(0.5)
      .setAlpha(0)

    // Instruction text (different for mobile vs desktop)
    const instructionText = this.add
      .text(x, y + 100, this.isMobile ? 'Tap Screen to Continue' : 'Press SPACE to Play Again', {
        fontSize: '24px',
        color: '#F8E71C',
        backgroundColor: '#000000',
        shadow: { fill: true, blur: 2, offsetY: 2 },
        padding: { left: 20, right: 20, top: 12, bottom: 12 },
      })
      .setOrigin(0.5)
      .setAlpha(0)

    // Animate texts appearing
    this.tweens.add({
      targets: titleText,
      alpha: 1,
      duration: 500,
      ease: 'Power2',
    })

    this.tweens.add({
      targets: gameOverText,
      alpha: 1,
      y: y + 20,
      duration: 800,
      delay: 300,
      ease: 'Bounce.easeOut',
    })

    this.tweens.add({
      targets: instructionText,
      alpha: 1,
      duration: 500,
      delay: 1000,
      ease: 'Power2',
    })

    // Make instruction text pulse
    this.tweens.add({
      targets: instructionText,
      scale: 1.05,
      duration: 600,
      yoyo: true,
      repeat: -1,
      delay: 1500,
      ease: 'Sine.easeInOut',
    })

    // Handle input based on device type
    if (this.isMobile) {
      // For mobile: tap anywhere to continue
      this.input.once('pointerdown', () => {
        this.scene.stop(SceneKeys.GameOver)
        this.scene.stop(SceneKeys.Game)
        this.scene.start(SceneKeys.HighScores, { score: data.score || 0 })
      })
    } else {
      // For desktop: press SPACE
      this.input.keyboard!.once('keydown-SPACE', () => {
        this.scene.stop(SceneKeys.GameOver)
        this.scene.stop(SceneKeys.Game)
        this.scene.start(SceneKeys.HighScores, { score: data.score || 0 })
      })
    }
  }
}
